import { AbilityBuilder } from "@casl/ability"
import { mapActions, mapState } from "vuex"

export default {
  watch: {
    async $route(to, from) {
      if (to.path != "/") {
        try {
          await this.getProfile()
        } catch (err) {
          this.$router.push("/")
        }
        this.initializeACL()
      }
    },
  },
  methods: {
    ...mapActions("auth", ["getProfile"]),
    initializeACL() {
      const { can, rules } = new AbilityBuilder()

      if (!this.permissions.length) return

      for (const permission of this.permissions) {
        can(
          permission.split("_")[0],
          permission
            .split("_")
            .slice(1)
            .join("_")
        )
      }
      this.$ability.update(rules)
    },
  },
  computed: {
    ...mapState("auth", ["permissions"]),
  },
}
